var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: {
        ios: _vm.$root.app.platform == "ios",
        android: _vm.$root.app.platform == "android",
        desktop: _vm.$root.app.platform == "desktop"
      },
      attrs: { id: "app" }
    },
    [
      _c("div", { attrs: { id: "main-heading" } }, [
        _vm.$root.app.platform == "desktop"
          ? _c("div", { staticClass: "logo__icon" })
          : _vm._e(),
        _vm._v(" "),
        _vm.$ui.backButtonState
          ? _c("div", { staticClass: "back-wrap" }, [
              _c(
                "div",
                {
                  staticClass: "back-button",
                  on: {
                    click: function($event) {
                      return _vm.back()
                    }
                  }
                },
                [
                  _vm.$root.app.platform == "android"
                    ? _c(
                        "div",
                        { staticClass: "back-button__icon" },
                        [_c("back-icon")],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.$root.app.platform == "ios"
                    ? _c("div", { staticClass: "back-button__icon" })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "title nav" }, [
                    _vm._v(_vm._s(_vm.$ui.backButtonString))
                  ])
                ]
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "title" }, [_vm._v(_vm._s(_vm.$ui.viewTitle))])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "loader", class: { show: _vm.$root.loading } }, [
        _c("div", { staticClass: "table" }, [
          _c("div", { staticClass: "cell" }, [
            _vm.$root.app.platform == "android"
              ? _c("div", [
                  _c("div", { staticClass: "indicator" }, [
                    _c(
                      "svg",
                      {
                        staticClass: "circular",
                        attrs: { viewBox: "25 25 50 50" }
                      },
                      [
                        _c("circle", {
                          staticClass: "path",
                          attrs: {
                            cx: "50",
                            cy: "50",
                            r: "20",
                            fill: "none",
                            "stroke-width": "4",
                            "stroke-miterlimit": "10"
                          }
                        })
                      ]
                    )
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.$root.app.platform == "ios"
              ? _c("div", [
                  _vm.$root.app.state === "save"
                    ? _c("span", { staticClass: "loader__text" }, [
                        _vm._v("Bezig met opslaan van jouw gegevens")
                      ])
                    : _c("span", { staticClass: "loader__text" }, [
                        _vm._v("Bezig met ophalen van jouw gegevens")
                      ]),
                  _vm._v(" "),
                  _vm._m(0)
                ])
              : _vm._e()
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "overlay transparent",
          class: { show: _vm.$root.ui.overlayToggled }
        },
        [
          _c(
            "div",
            {
              staticClass: "dialogbox",
              class: { show: _vm.$root.ui.dialog.state }
            },
            [
              _c("div", { staticClass: "title" }, [
                _vm._v(_vm._s(_vm.$root.ui.dialog.title))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "description" }, [
                _vm.$root.ui.dialog.editable != true
                  ? _c("div", {
                      domProps: {
                        innerHTML: _vm._s(_vm.$root.ui.dialog.description)
                      }
                    })
                  : _c("div", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.$root.ui.dialog.description,
                            expression: "$root.ui.dialog.description"
                          }
                        ],
                        attrs: { type: "text" },
                        domProps: { value: _vm.$root.ui.dialog.description },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.$root.ui.dialog,
                              "description",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ])
              ]),
              _vm._v(" "),
              _vm.$root.ui.dialog.options
                ? _c(
                    "div",
                    {
                      staticClass: "options-wrap",
                      class:
                        "options-" +
                        Object.keys(_vm.$root.ui.dialog.options).length
                    },
                    _vm._l(_vm.$root.ui.dialog.options, function(item, index) {
                      return _c(
                        "div",
                        { staticClass: "option", class: "option-" + index },
                        [
                          item.action
                            ? _c("div", [
                                _c("a", { attrs: { href: item.action } }, [
                                  _c(
                                    "button",
                                    {
                                      on: {
                                        click: function($event) {
                                          return _vm.$root.ui.dialogOptionClicked(
                                            index
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(item.name))]
                                  )
                                ])
                              ])
                            : _c("div", [
                                _c(
                                  "button",
                                  {
                                    on: {
                                      click: function($event) {
                                        return _vm.$root.ui.dialogOptionClicked(
                                          index
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(item.name))]
                                )
                              ])
                        ]
                      )
                    }),
                    0
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.$root.ui.dialog.cancellable
                ? _c("div", { staticClass: "cancel" }, [
                    _c("div", { staticClass: "option" }, [
                      _c(
                        "button",
                        {
                          on: {
                            click: function($event) {
                              return _vm.$root.ui.hideOverlay()
                            }
                          }
                        },
                        [_vm._v("Sluiten")]
                      )
                    ])
                  ])
                : _vm._e()
            ]
          )
        ]
      ),
      _vm._v(" "),
      _vm.$root.app.platform == "desktop"
        ? _c("div", { staticClass: "desktop_breadcrumbs" }, [
            _c("div", { staticClass: "title nav" }, [
              _vm._v(_vm._s(_vm.$ui.backButtonString))
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "content expand" }, [_c("router-view")], 1)
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "ispinner ispinner--animating ispinner--gray" },
      [
        _c("div", { staticClass: "ispinner__blade" }),
        _vm._v(" "),
        _c("div", { staticClass: "ispinner__blade" }),
        _vm._v(" "),
        _c("div", { staticClass: "ispinner__blade" }),
        _vm._v(" "),
        _c("div", { staticClass: "ispinner__blade" }),
        _vm._v(" "),
        _c("div", { staticClass: "ispinner__blade" }),
        _vm._v(" "),
        _c("div", { staticClass: "ispinner__blade" }),
        _vm._v(" "),
        _c("div", { staticClass: "ispinner__blade" }),
        _vm._v(" "),
        _c("div", { staticClass: "ispinner__blade" }),
        _vm._v(" "),
        _c("div", { staticClass: "ispinner__blade" }),
        _vm._v(" "),
        _c("div", { staticClass: "ispinner__blade" }),
        _vm._v(" "),
        _c("div", { staticClass: "ispinner__blade" }),
        _vm._v(" "),
        _c("div", { staticClass: "ispinner__blade" })
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ba5bd90", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ba5bd90","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 